/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import { smartphoneDuocolor } from "../assets/smartphone-duocolor";
import {
  type StaticIllustrativeBaseIconProps,
  StaticIllustrativeIcon,
} from "../static-illustrative-icon";

export const IllustrativeIconSmartphoneDuocolor = (props: StaticIllustrativeBaseIconProps) => (
  <StaticIllustrativeIcon {...props} svg={smartphoneDuocolor.svg} />
);

IllustrativeIconSmartphoneDuocolor.displayName = "IllustrativeIconSmartphoneDuocolor";
